import { Box, Chip, ListItemText, Menu } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity } from 'app/entities/truck-implement/truck-implement.reducer';
import React, { useEffect } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

export const truckImplementPartialHeader = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const truckImplement = useAppSelector(state => state.truckImplement.entity);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const getTruckImplementInfo = () => {
    dispatch(getEntity(props.match.params.id));
  };

  useEffect(() => {
    getTruckImplementInfo();
  }, []);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!truckImplement) {
      getTruckImplementInfo();
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box width={'100%'}>
      {truckImplement?.licensePlate && (
        <Chip
          label={truckImplement.licensePlate}
          onClick={handleClick}
          color="secondary"
          clickable
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: { xs: '150px', sm: '300px' },
          }}
        />
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          top: 5,
        }}
        MenuListProps={{
          sx: {
            padding: 1,
            backgroundColor: 'background.paper',
          },
        }}
      >
        {truckImplement?.image && (
          <img src={`data:image/*;base64,${truckImplement.image}`} alt="Truck Implement" style={{ width: '200px', objectFit: 'cover' }} />
        )}
        <ListItemText
          sx={{ display: 'flex', flexDirection: 'column-reverse', whiteSpace: 'nowrap' }}
          secondary={translate('fleetSenseApp.truckImplement.licensePlate')}
          primaryTypographyProps={{ variant: 'body2' }}
          primary={truckImplement.licensePlate ?? '-'}
        />

        {truckImplement?.description && (
          <ListItemText
            sx={{ display: 'flex', flexDirection: 'column-reverse', whiteSpace: 'nowrap' }}
            secondary={translate('fleetSenseApp.sensor.description')}
            primaryTypographyProps={{ variant: 'body2' }}
            primary={truckImplement.description ?? '-'}
          />
        )}
      </Menu>
    </Box>
  );
};
